export interface IPlacename {
    objectId?: number;
    smithName: string;
    smithName2?: string;
    englishName: string;
    county?: string;
    translation?: string;
    name1?: string;
    meaning1?: string;
    source1?: string;
    sourceDetail1?: string;
    name2?: string;
    meaning2?: string;
    source2?: string;
    sourceDetail2?: string;
    name3?: string;
    meaning3?: string;
    source3?: string;
    sourceDetail3?: string;
    name4?: string;
    meaning4?: string;
    source4?: string;
    sourceDetail4?: string;
    name5?: string;
    meaning5?: string;
    source5?: string;
    sourceDetail5?: string;
    comment?: string;
    audioLink?: string;
    video?: string;
    approved?: number;
    enteredBy?: string;
    x: number;
    y: number;
}

export class Placename implements IPlacename {
    public smithName: string = '';
    public englishName: string = '';
    public x: number = 0;
    public y: number = 0;
    public objectId?: number; // OID will not be populated on new features
    public smithName2?: string;
    public county?: string;
    public translation?: string;
    public name1?: string;
    public meaning1?: string;
    public source1?: string;
    public sourceDetail1?: string;
    public name2?: string;
    public meaning2?: string;
    public source2?: string;
    public sourceDetail2?: string;
    public name3?: string;
    public meaning3?: string;
    public source3?: string;
    public sourceDetail3?: string;
    public name4?: string;
    public meaning4?: string;
    public source4?: string;
    public sourceDetail4?: string;
    public name5?: string;
    public meaning5?: string;
    public source5?: string;
    public sourceDetail5?: string;
    public comment?: string;
    public audioLink?: string;
    public video?: string;
    public approved?: number;
    public enteredBy?: string;
    constructor(attributes?: any) { // constructor for Graphic attributes
        this.smithName = attributes && attributes.SmithName;
        this.englishName = attributes && attributes.EnglishName;
        this.objectId = attributes && attributes.OBJECTID;
        this.smithName2 = attributes && attributes.SmithName2;
        this.county = attributes && attributes.County;
        this.translation = attributes && attributes.SmithProperTranslation;
        this.name1 = attributes && attributes.name1;
        this.meaning1 = attributes && attributes.meaning1;
        this.source1 = attributes && attributes.source1;
        this.sourceDetail1 = attributes && attributes.source_detail1;
        this.name2 = attributes && attributes.name2;
        this.meaning2 = attributes && attributes.meaning2;
        this.source2 = attributes && attributes.source2;
        this.sourceDetail2 = attributes && attributes.source_detail2;
        this.name3 = attributes && attributes.name3;
        this.meaning3 = attributes && attributes.meaning3;
        this.source3 = attributes && attributes.source3;
        this.sourceDetail3 = attributes && attributes.source_detail3;
        this.name4 = attributes && attributes.name4;
        this.meaning4 = attributes && attributes.meaning4;
        this.source4 = attributes && attributes.source4;
        this.sourceDetail4 = attributes && attributes.source_detail4;
        this.name5 = attributes && attributes.name5;
        this.meaning5 = attributes && attributes.meaning5;
        this.source5 = attributes && attributes.source5;
        this.sourceDetail5 = attributes && attributes.source_detail5;
        this.comment = attributes && attributes.Comment;
        this.audioLink = attributes && attributes.AudioLink;
        this.video = attributes && attributes.Video;
        this.approved = attributes && attributes.approved;
        this.enteredBy = attributes && attributes.entered_by;
    }
}
